import type { TFunction } from "i18next";
import toast from "react-hot-toast";

interface PaymentFileWarning {
  code: string;
  count: number;
  employees?: Array<{ name: string | null }>;
}

/**
 * After a bank (SIF) file is built: employees whose IBAN is in the UAE shape
 * but fails its check digits are in the file, and the bank is likely to
 * reject their row (B50). Not blocking — said once, with the names, so it can
 * be fixed before the file is sent.
 */
export const warnIfIbanChecksumFails = <T>(response: T, t: TFunction): T => {
  const body = response as unknown as {
    warnings?: PaymentFileWarning[];
    data?: { warnings?: PaymentFileWarning[] };
  };
  const warnings = body?.data?.warnings ?? body?.warnings ?? [];
  const hit = warnings.find((w) => w.code === "IBAN_CHECKSUM");
  if (hit) {
    const names = (hit.employees ?? [])
      .map((e) => e.name)
      .filter(Boolean)
      .join(", ");
    toast(
      t("company:payrolls.iban_checksum_warning", {
        count: hit.count,
        names,
      }),
      { icon: "⚠️", duration: 10000 },
    );
  }
  return response;
};
